import { graphql } from "@opensea/graphql"

export const TradingViewChartFragment = graphql(`
  fragment TradingViewChart on Currency {
    pools {
      name
      dexScreenerChainId
      pool {
        contractAddress
      }
    }
  }
`)

export const TradingViewChartButtonFragment = graphql(
  `
  fragment TradingViewChartButton on Currency {
    contractAddress
    chain {
      identifier
    }
  }
`,
  [],
)
